import { mapActions } from 'vuex'
export default {
  async created() {
    await this.updateGlobalOptions()
  },
  methods: {
    ...mapActions('common', [ 'updateGlobalOptions']),
  }
}
